import { jsx } from "react/jsx-runtime";
import { useIsBrazil } from "@crehana/i18n";
import { useMediaQuery } from "@crehana/react-hooks";
import useAcademiesQuery from "./hooks/useAcademiesQuery.js";
import { useMainMenuContext } from "../../hooks/index.js";
import LeftMenuDesktop from "./layout/LeftMenuDesktop/index.js";
import LeftMenuMobile from "./layout/LeftMenuMobile/index.js";
const LeftMenu = ()=>{
    const { variant, loadingMe, me, layoutConfig, onLeftMenuOpen } = useMainMenuContext();
    const isBrazil = useIsBrazil();
    const { buckets } = useAcademiesQuery();
    const { matches: isSm } = useMediaQuery('sm');
    const shouldRenderLeaderLink = !layoutConfig.hideCenteredLeaderDashboardLink;
    const shouldRenderCategories = !layoutConfig.hideCategories;
    const shouldRenderSolutionsMenu = !layoutConfig.hideSolutionsMenu;
    const shouldRenderNewCourses = !layoutConfig.hideNewCourses;
    const shouldRenderAcademies = !layoutConfig.hideAcademies && !!buckets.length;
    const shouldRenderMicroDegrees = !layoutConfig.hideMicroDegrees && !isBrazil;
    const shouldRenderResourcesButton = !layoutConfig.hideResourcesDropdown;
    const shouldRenderAdminDashboardLink = me.isB2BAdmin && !layoutConfig.hideB2BAdminDashboardLink;
    const shouldRenderPremiumLandingLink = (me.isAnonymous || me.isPAYG) && !layoutConfig.hidePremiumLandingLink;
    const shouldRenderB2BLandingLink = !loadingMe && !me.isB2B && !layoutConfig.hideB2BLandingLink;
    const shouldRenderInboxLink = me.hasInboxAccess && !layoutConfig.hideInboxLink && !me.isPremium || me.isMentor && !layoutConfig.hideInboxLink;
    const shouldRenderShoppingCartLink = (me.isAnonymous || me.isPAYG) && !layoutConfig.hideShoppingCart;
    const shouldHelpCenterLink = !layoutConfig.hideHelpCenterLink;
    const shouldRenderRegisterButton = me.isAnonymous && !layoutConfig.hideRegisterButton;
    const shouldRenderLoginButton = me.isAnonymous && !layoutConfig.hideLoginButton;
    const shouldRenderAppLinks = !layoutConfig.hideAppLinks;
    const shouldRenderHigherEdLink = !layoutConfig.hideHigherEdLink;
    const getShouldRenderCatalogMenu = ()=>{
        if (layoutConfig.hideCatalogDropdown) return false;
        return me.isB2BAllCatalog && (shouldRenderCategories || shouldRenderNewCourses || shouldRenderAcademies || shouldRenderMicroDegrees) || me.isB2BAdmin;
    };
    const shouldRenderCatalogMenu = getShouldRenderCatalogMenu();
    const shouldRenderCatalogAtEnd = shouldRenderCatalogMenu && Boolean(layoutConfig.renderCatalogAtEnd);
    const isEveryLeftDesktopActionVisible = shouldRenderCatalogMenu && shouldRenderResourcesButton && shouldRenderPremiumLandingLink && (shouldRenderB2BLandingLink || shouldRenderAdminDashboardLink);
    const shouldRenderDegreesButton = !layoutConfig.hideDegreesDropdown && !isBrazil && !me.isB2BOnlyPanel && !me.isB2BAllCatalog && (!me.isAnonymous || !(isEveryLeftDesktopActionVisible && shouldRenderShoppingCartLink));
    const shouldRenderBlogCategories = !layoutConfig.hideBlogCategories;
    const shouldRenderDesktopBlogLeftMenu = !layoutConfig.hideDesktopBlogLeftMenu;
    const shouldRenderDownloadableResources = !layoutConfig.hideDownloadableResouces;
    const shouldRenderSocialLinks = !layoutConfig.hideSocialLinks;
    if (layoutConfig.hideEveryLeftMenuAction) return null;
    const leftMenuCommonProps = {
        shouldRenderCatalogMenu,
        shouldRenderSolutionsMenu,
        shouldRenderCategories,
        shouldRenderNewCourses,
        shouldRenderAcademies,
        shouldRenderMicroDegrees,
        shouldRenderResourcesButton,
        shouldRenderDegreesButton,
        shouldRenderAdminDashboardLink,
        shouldRenderPremiumLandingLink,
        shouldRenderB2BLandingLink,
        shouldRenderCatalogAtEnd,
        shouldRenderBlogCategories,
        shouldRenderDownloadableResources,
        shouldRenderSocialLinks,
        shouldRenderDesktopBlogLeftMenu,
        shouldRenderHigherEdLink,
        shouldRenderLeaderLink,
        onLeftMenuOpen
    };
    if ('light' !== variant && isSm) return /*#__PURE__*/ jsx(LeftMenuDesktop, {
        className: "flex",
        ...leftMenuCommonProps
    });
    return /*#__PURE__*/ jsx(LeftMenuMobile, {
        ...leftMenuCommonProps,
        shouldRenderInboxLink: shouldRenderInboxLink,
        shouldRenderShoppingCartLink: shouldRenderShoppingCartLink,
        shouldHelpCenterLink: shouldHelpCenterLink,
        shouldRenderRegisterButton: shouldRenderRegisterButton,
        shouldRenderLoginButton: shouldRenderLoginButton,
        shouldRenderAppLinks: shouldRenderAppLinks
    });
};
const LeftMenu_LeftMenu = LeftMenu;
export default LeftMenu_LeftMenu;
